module.exports = __webpack_public_path__ + "images/6e6961cfecad68328097238a7180e626-WDWS_NO_SR logos BLUE-01.png";